import { CURRENCY_CODE } from "@/lib/constant";
import { sendGTMEvent } from "@next/third-parties/google";
import { formatItems } from "@repo/lib/helpers";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useBeginCheckout = () => {
  const isGTMEnabled = useFeatureFlag("gtm");
  const handleBeginCheckoutEvent = useCallback(
    (cart) => {
      if (!isGTMEnabled) {
        return;
      }
      const { cartTotal, lineItems, couponName } = cart;
      sendGTMEvent({
        event: "begin_checkout",
        currency: CURRENCY_CODE,
        value: cartTotal?.total,
        coupon: couponName || "",
        items: formatItems(lineItems, couponName),
      });
    },
    [isGTMEnabled]
  );

  return { handleBeginCheckoutEvent };
};

export default useBeginCheckout;
